"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubscriptionWasCancelled = exports.hasAccessToChannelByPricingPlan = exports.getDealInfo = exports.isPricingPlanEnabled = exports.isSubscriptionEnabled = exports.isSubscribedTo = void 0;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var dealInfoHelpers = (0, tslib_1.__importStar)(require("../../utils/deal-info-helpers"));
function isSubscribedTo(channel) {
    return Boolean((0, lodash_1.get)(channel, 'dgsInfo.subscription'));
}
exports.isSubscribedTo = isSubscribedTo;
function isSubscriptionEnabled(channel) {
    return Boolean(dealInfoHelpers.getSubscriptionPriceInfo(channel.dealInfo));
}
exports.isSubscriptionEnabled = isSubscriptionEnabled;
function isPricingPlanEnabled(_a) {
    var dealInfo = _a.dealInfo;
    return Boolean(dealInfoHelpers.getPricingPlanInfo(dealInfo));
}
exports.isPricingPlanEnabled = isPricingPlanEnabled;
function getDealInfo(props) {
    return (0, lodash_1.get)(props, 'channelData.dealInfo');
}
exports.getDealInfo = getDealInfo;
function hasAccessToChannelByPricingPlan(channelInfo) {
    return channelInfo.hasAccessToChannelByPricingPlan;
}
exports.hasAccessToChannelByPricingPlan = hasAccessToChannelByPricingPlan;
function isSubscriptionWasCancelled(channel) {
    return Boolean((0, lodash_1.get)(channel, 'dgsInfo.subscription.expirationTs'));
}
exports.isSubscriptionWasCancelled = isSubscriptionWasCancelled;
//# sourceMappingURL=pricing.js.map